import { Platform } from 'react-native';

export type Brand = 'alto' | 'fuzehealth';

/**
 * Get the brand of the current website. Used to determine the correct colors and other branding assets to load.
 * @returns Brand ('alto' or 'fuzehealth')
 */
export const getBrand = (): Brand => {
  if (Platform.OS === 'ios' || Platform.OS === 'android') {
    return 'alto';
  }

  const host = window.location.hostname.toLowerCase();

  if (host.includes('alto')) {
    return 'alto';
  }

  if (host.includes('fuzehealth')) {
    return 'fuzehealth';
  }

  throw new Error('Unable to resolve brand');
};
